import React, { useEffect, useState } from "react";
import "./Banner.css";
import api from "../Services/api";
import { CachedBannerImage } from "./BannerMemo";
const HomeBanner = () => {
  const [banners, setBanner] = useState<any[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ssrBannerDetected, setSsrBannerDetected] = useState(false);

  const buildImageUrl = (url: string) => {
    if (!url) return "";
    if (url.startsWith('http')) return url;
    if (url.startsWith('/')) {
      return `https://institucional.forluz.org.br${url}`;
    }
    return url;
  };

  useEffect(() => {
    const ssrBanner = document.getElementById('ssr-banner-wrapper');
    if (ssrBanner) {
      setSsrBannerDetected(true);
    }
    api
      .get("/ObterBanners")
      .then((response) => {
        const apiBanners = response.data.results || [];

        const activeBanners = apiBanners.filter((banner: any) => {
          if (!banner.Ativo) return false;

          const now = new Date();
          const startDate = banner.Inicio_x0020_Campanha
            ? new Date(banner.Inicio_x0020_Campanha)
            : null;
          const endDate = banner.Fim_x0020_Campanha
            ? new Date(banner.Fim_x0020_Campanha)
            : null;

          if (startDate && now < startDate) return false;
          if (endDate && now > endDate) return false;

          return true;
        });

        const processedBanners = activeBanners.map((banner: any) => {
          const processedUrl = buildImageUrl(banner.URL);
          return {
            ...banner,
            URL: processedUrl
          };
        });

        setBanner(processedBanners);
      })
      .catch((err) => {
        console.error("Erro ao carregar banners:", err);
      });
  }, []);

  useEffect(() => {
    if (banners.length > 0) {
      const ssrWrapper = document.getElementById('ssr-banner-wrapper');
      if (ssrWrapper) {
        ssrWrapper.remove();
      }
      // Preload de todas as imagens assim que a lista chegar
      banners.forEach((b) => {
        if (!b?.URL) return;
        const img = new Image();
        img.src = b.URL;
      });
    }
  }, [banners]);

  useEffect(() => {
    if (banners.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === banners.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [banners.length]);

  const handlePrevClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (banners.length > 1) {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? banners.length - 1 : prevIndex - 1
      );
    }
  };

  const handleNextClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (banners.length > 1) {
      setCurrentIndex((prevIndex) =>
        prevIndex === banners.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  if (!banners || banners.length === 0) {
    if (ssrBannerDetected) {
      return (
        <section className="banner-container">
          <div className="banner-content">
            {/* SSR continua visível aqui */}
          </div>
        </section>
      );
    }
    return null;
  }

  return (
    <section className="banner-container">
      <div className="banner-content">
        <div className="banner-slides-wrapper">
          {banners.map((banner, index) => (
            <div
              key={banner.ID || `banner-${index}`}
              className={`banner-item${index === currentIndex ? " banner-item--active" : ""}`}
              aria-hidden={index !== currentIndex}
            >
              {banner?.URL ? (
                <a
                  href={banner.Link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="banner-image-wrapper">
                    <CachedBannerImage
                      banner={banner}
                      index={index}
                      className="banner-background-image"
                    />
                  </div>
                  <div className="banner-overlay-text">
                    <h1 className="banner-title">{banner?.Title}</h1>
                    {banner?.Descricao && (
                      <p className="banner-description">{banner?.Descricao}</p>
                    )}
                  </div>
                </a>
              ) : (
                <div>
                  <div className="banner-image-wrapper">
                    <CachedBannerImage
                      banner={banner}
                      index={index}
                      className="banner-background-image"
                    />
                  </div>
                  <div className="banner-overlay-text">
                    <h1 className="banner-title">{banner?.Title}</h1>
                    {banner?.Descricao && (
                      <p className="banner-description">{banner?.Descricao}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}

          {/* Setas de navegação */}
          <div
            className={`banner-navigation ${banners.length <= 1 ? "disabled" : ""}`}
          >
            <button
              className="banner-nav-btn banner-prev"
              onClick={handlePrevClick}
              aria-label="Banner anterior"
              type="button"
              disabled={banners.length <= 1}
            >
              ←
            </button>
            <button
              className="banner-nav-btn banner-next"
              onClick={handleNextClick}
              aria-label="Próximo banner"
              type="button"
              disabled={banners.length <= 1}
            >
              →
            </button>
          </div>

          {/* Indicadores de posição */}
          <div className="banner-indicators">
            {banners.map((_, index) => (
              <button
                key={index}
                className={`banner-indicator ${index === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Ir para banner ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;